import React from 'react';
import { unmountComponentAtNode } from 'react-dom';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { OneFaceProvider } from 'onefaceui-react-components';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from 'react/services/queryClient';

import { getOneFaceProviderResources } from './onefaceLibraryUtils';

function CustomProvider({ children }) {
  return (
    <Provider store={window.globalStore}>
      <QueryClientProvider client={queryClient}>
        <OneFaceProvider resources={getOneFaceProviderResources()}>
          {children}
        </OneFaceProvider>
      </QueryClientProvider>
    </Provider>
  );
}
const roots = new WeakMap();

const renderComponent = (component, container) => {
  let root = roots.get(container);
  if (!root) {
    root = createRoot(container);
    roots.set(container, root);
  }
  root.render(component);
};

const checkAndUnmountComponentByNode = (container) => {
  if (roots.has(container)) {
    const root = roots.get(container);
    root.unmount();
    roots.delete(container);
  }
};

const unmountComponentByNode = (node) => unmountComponentAtNode(node);

export {
  CustomProvider,
  renderComponent,
  checkAndUnmountComponentByNode,
  unmountComponentByNode
};
